import React from "react"
import {TimePicker} from "antd"
import 'dayjs/locale/ru';
import locale from 'antd/es/date-picker/locale/ru_RU'
import classes from "./CustomTimePicker.module.scss"
import dayjs, {Dayjs} from "dayjs"

interface ICustomTimePickerProps {
  name: string
  timeFormat?: string
  className?: string
  label?: string
  value?: Dayjs
  curTime?: string
  required?: boolean
  valid?: boolean
  shouldValidate?: boolean
  errorMessage?: string
  touched?: boolean,
  onChangeTime?: any
  disabled?: boolean
}

function CustomTimePicker({
                            className,
                            required,
                            valid,
                            shouldValidate,
                            errorMessage,
                            curTime,
                            onChangeTime,
                            label,
                            timeFormat = "HH:mm",
                            ...rest
                          }: ICustomTimePickerProps) {

  let cls = [classes.wrap]

  if (className) {
    cls = [...cls, className]
  }

  if (required) {
    cls = [...cls, classes.requred]
  }

  if (!valid && shouldValidate) {
    cls = [...cls, classes.error]
    cls = [...cls, "ant-picker-custom-error"]
  }

  const errorMessageTemplate = errorMessage && <span className={classes.error_message}>{errorMessage}</span>
  const labelTemplate = label ? <label className={classes.label}>{label}</label> : null

  if (curTime) {
    rest.value = dayjs(curTime, timeFormat)
  }

  return (
    <div
      className={cls.join(" ")}
    >
      <div className={classes.container}>
        {labelTemplate}
        <TimePicker
          format={timeFormat}
          locale={locale}
          className={"ant-picker-custom"}
          onChange={value => {
            const formattedTime = value ? value.format(timeFormat) : ""
            onChangeTime(formattedTime)
          }}
          {...rest}
        />
      </div>
      {errorMessageTemplate}
    </div>
  )

}

export default CustomTimePicker